<template>
    <div class="EnvironmentSwitcher">
        <a href="#" class="EnvironmentSwitcher__toggler hidden-md hidden-lg" @click.prevent="toggle">
            <i class="fa fa-sliders" aria-hidden="true"></i>
        </a>
        <ul class="Utility__list-inline" v-show="display">
            <li v-for="environment in environments">
                <a href="#"
                   :class="classes(environment)"
                   @click.prevent="changeEnvironment(environment)"
                >
                    {{ environment }}
                </a>
            </li>
        </ul>

        <form action="/change-environment" ref="form" method="post">
            <input name="_token" type="hidden" :value="csrfToken">
            <input name="environment" type="hidden" v-model="changeTo">
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                environments: ['Live', 'Staging', 'Pre-Live'],
                changeTo: '',
                csrfToken: Laravel.csrfToken,
                show: false,
                windowWidth: '',
            }
        },

        props: {
            currentEnvironment: {
                required: true,
                type: String
            }
        },

        mounted() {
            bus.$on('hide-cover-alls', (caller) => {
                if (caller != 'environment-switcher') {
                    this.show = false;
                }
            });

            this.handleResize();

            window.addEventListener('resize', this.handleResize);
        },

        computed: {
            display() {
                if ((this.show == true && this.windowWidth <= 991) || this.windowWidth > 991) {
                    return true;
                }

                return false;
            },
        },

        methods: {
            classes(environment) {
                return {
                    'EnvironmentSwitcher__environment': true,
                    'EnvironmentSwitcher__environment--is-active': environment == this.currentEnvironment,
                }
            },

            changeEnvironment(environment) {
                if (environment == this.currentEnvironment) return;

                this.changeTo = environment;

                bus.$emit('show-loading-overlay');

                this.show = false;

                _.defer(() => {
                    this.$refs.form.submit()
                })
            },

            handleResize() {
                this.windowWidth = document.documentElement.clientWidth;
            },

            toggle() {
                if (this.show) {
                    this.show = false;
                } else {
                    this.show = true;

                    bus.$emit('hide-cover-alls', 'environment-switcher');
                }
            }
        }
    }
</script>